import React from "react";

import { Button } from "@replo/design-system/components/button/Button";
import { Popover } from "@replo/design-system/components/popover/Popover";
import { Tooltip } from "@replo/design-system/components/tooltip/Tooltip";
import shouldShowV2Debuggers from "@v2/utils/shouldShowV2Debuggers";
import { CircleX, MoreHorizontal } from "lucide-react";

const ErrorCard = ({
  title,
  subtitle,
  errorMessage,
}: {
  title: string;
  subtitle: string;
  errorMessage?: string;
}) => {
  const isDebug = shouldShowV2Debuggers();

  return (
    <div className="border-0.5 border-border flex flex-col gap-6 rounded-xl p-0 shadow-sm w-full">
      <div className="flex flex-col items-start gap-2 p-4">
        <div className="flex flex-row gap-3 items-start">
          <Button
            icon
            variant="secondary"
            UNSAFE_className="bg-rose-soft border-rose/50"
          >
            <CircleX size={16} className="text-rose" />
          </Button>
          <div className="flex flex-col gap-1">
            <div className="text-sm font-semibold">{title}</div>
            <div className="text-xs text-muted relative">{subtitle}</div>
          </div>
          {isDebug && errorMessage && (
            <Popover
              triggerAsChild
              side="bottom"
              align="start"
              sideOffset={8}
              UNSAFE_className="w-[500px]"
              title="Error Message"
              trigger={
                <Tooltip content="View debug diffs">
                  <Button icon variant="secondary" size="sm">
                    <MoreHorizontal className="size-4" />
                  </Button>
                </Tooltip>
              }
            >
              <div className="max-h-96 overflow-auto flex flex-col gap-2">
                <pre className="text-2xs text-neutral-soft p-2 rounded border mb-2 whitespace-pre-wrap">
                  {errorMessage}
                </pre>
              </div>
            </Popover>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorCard;
